import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureEntitlements } from './featureEntitlements'

const minICPlatformVersion = ICPlatformVersion.r2024_11_0
export const legacyReadOnlyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ReadOnly],
}

export const siteManagementNavigationAccessControl = {
  featureEntitlementIds: [FeatureEntitlements.Navigation],
  permissions: [Permission.StoreConfigsView, Permission.StorefrontNavigationView],
  minICPlatformVersion,
} satisfies DomainAccessControlConfig

export const siteManagementNavigationModifyAccessControl = {
  featureEntitlementIds: [FeatureEntitlements.Navigation],
  permissions: [Permission.StoreConfigsModify],
  minICPlatformVersion,
} satisfies DomainAccessControlConfig
